import { Component, inject } from '@angular/core';
import { MillSectorService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  MillSectorCreateDto,
  MillSectorDto,
  MillSectorExcelDownloadDto,
  MillSectorUpdateDto,
} from '../proxy/planning/dtos/mill-sector';
import { MILLSECTOR_CONFIG, MILLSECTOR_FIELDS } from './mill-sector.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-mill-sector',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, MillSectorService, ConfirmationService],
  templateUrl: './mill-sector.html',
  styleUrl: './mill-sector.scss',
})
export class MillSector extends BaseHierarchicalCrudComponent<
  MillSectorDto,
  MillSectorCreateDto,
  MillSectorUpdateDto,
  MillSectorExcelDownloadDto
> {
  service = inject(MillSectorService);
  config = MILLSECTOR_CONFIG;
  fields = MILLSECTOR_FIELDS;

  protected prepareUpdateDto(data: any, selected: MillSectorDto): MillSectorUpdateDto {
    return {
      name: data.name,
      remsoftName: data.remsoftName,
      isActive: data.isActive,
      millId: data.millId,
      locationId: data.locationId,
      millSectorTypeId: data.millSectorTypeId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'MillSector';
  }
}
